import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../../../components/ui/card';
import { useAnalyticsContext } from '../analytics-context';

const GaTopPages: React.FC = () => {
  const { ga, isCustomRangePending } = useAnalyticsContext();
  const topPagesError = ga.topPages.error as any;

  if (!ga.integration.isConfigured) {
    return (
      <Card className="border-none shadow-sm h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold">Top Pages</CardTitle>
        </CardHeader>
        <CardContent className="flex h-[220px] items-center justify-center text-sm text-muted-foreground">
          {ga.integration.message ||
            'Connect Google Analytics to see top-performing pages.'}
        </CardContent>
      </Card>
    );
  }

  if (topPagesError && topPagesError.status && topPagesError.status !== 400) {
    return (
      <Card className="border-none shadow-sm h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold">Top Pages</CardTitle>
        </CardHeader>
        <CardContent className="flex h-[220px] items-center justify-center text-sm text-red-600">
          {topPagesError.data?.message ||
            topPagesError.message ||
            'Failed to load top pages data.'}
        </CardContent>
      </Card>
    );
  }

  if (ga.topPages.isLoading) {
    return (
      <Card className="border-none shadow-sm h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold">Top Pages</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div
              key={idx}
              className="space-y-2 rounded-lg border bg-card/50 p-3"
            >
              <div className="h-4 w-40 animate-pulse rounded bg-muted/50" />
              <div className="flex gap-2 text-xs text-muted-foreground">
                <div className="h-3 w-16 animate-pulse rounded bg-muted/40" />
                <div className="h-3 w-12 animate-pulse rounded bg-muted/30" />
                <div className="h-3 w-12 animate-pulse rounded bg-muted/20" />
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    );
  }

  if (isCustomRangePending) {
    return (
      <Card className="border-none shadow-sm h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold">Top Pages</CardTitle>
        </CardHeader>
        <CardContent className="flex h-[220px] items-center justify-center text-sm text-muted-foreground">
          Select a start and end date to view Google Analytics insights.
        </CardContent>
      </Card>
    );
  }

  if (!ga.topPages.data.length) {
    return (
      <Card className="border-none shadow-sm h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold">Top Pages</CardTitle>
        </CardHeader>
        <CardContent className="flex h-[220px] items-center justify-center text-sm text-muted-foreground">
          No page performance data available for this period.
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-none shadow-sm h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-semibold">Top Pages</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {ga.topPages.data.map(page => (
          <div
            key={page.path}
            className="space-y-1 rounded-lg border bg-card/50 p-3"
          >
            <p className="truncate text-sm font-medium text-foreground">
              {page.path}
            </p>
            <div className="flex flex-wrap gap-x-4 text-xs text-muted-foreground">
              <span>{page.views.toLocaleString()} views</span>
              <span>
                Avg. duration:{' '}
                {Math.round(page.avgDurationSeconds / 60)}
                m
                {page.avgDurationSeconds % 60}s
              </span>
              <span>Bounce: {page.bounceRate.toFixed(1)}%</span>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default GaTopPages;

